import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";
import { trackShareAdded } from "../analytics";
import {
  ShareRequest,
  UnshareRequest,
  GetSharesForSourceRequest,
  GetSharesForSourceResponse,
  StandardResponse,
  GetMySharesRequest,
  GetMySharesResponse,
  ShareModel,
} from "common247";

export async function share(fb: FirebaseServices, request: ShareRequest): Promise<StandardResponse> {
  const result = (await callFunction(fb, "shareFunc", request)) as StandardResponse;
  if (result && result.status !== false) {
    trackShareAdded(request.sourceId || "share", request.sourceType || "item", request.targetType);
  }
  return result;
}

export async function unshare(fb: FirebaseServices, request: UnshareRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "unshareFunc", request);
  return result as StandardResponse;
}

export async function getSharesForSource(fb: FirebaseServices, request: GetSharesForSourceRequest): Promise<GetSharesForSourceResponse> {
  const result = await callFunction(fb, "getSharesForSourceFunc", request);
  return result as GetSharesForSourceResponse;
}

export async function getMyShares(fb: FirebaseServices, request: GetMySharesRequest): Promise<GetMySharesResponse> {
  const result = await callFunction(fb, "getMySharesFunc", request);
  return result as GetMySharesResponse;
}

/**
 * Admin function to retrieve all shares across all users and entities.
 * Requires admin privileges.
 */
export async function getAllShares(
  fb: FirebaseServices,
  request: Record<string, any> = {},
): Promise<{ status: boolean; shares: ShareModel[]; error?: string }> {
  const result = await callFunction(fb, "getAllSharesFunc", request);
  return result as { status: boolean; shares: ShareModel[]; error?: string };
}

export interface ICheckEntityLinksRequest {
  entityType: "memory" | "group" | "media" | "contact" | "place" | "anchor";
  entityId: string;
}

export interface ICheckEntityLinksResponse {
  status: boolean;
  hasLinks: boolean;
  totalLinks: number;
  links: {
    memories: Array<{ id: string; title: string; type: string }>;
    media: Array<{ id: string; title: string; type: string }>;
    groups: Array<{ id: string; title: string; type: string }>;
    contacts: Array<{ id: string; title: string; type: string }>;
    places?: Array<{ id: string; title: string; type: string }>;
    anchors?: Array<{ id: string; title: string; type: string }>;
    shares: Array<{ id: string; title: string; type: string }>;
  };
  summaryText: string;
  error?: string;
}

/**
 * Checks all active references and links pointing to or originating from an entity before deletion.
 */
export async function checkEntityLinks(
  fb: FirebaseServices,
  request: ICheckEntityLinksRequest
): Promise<ICheckEntityLinksResponse> {
  const result = await callFunction(fb, "checkEntityLinksFunc", request);
  return result as ICheckEntityLinksResponse;
}

